export default function BackIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            aria-hidden="true"
            viewBox="0 0 24 24"
        >
            <path
                fill="#08F"
                d="M10.83 11H17v2h-6.17l2.58 2.59L12 17l-5-5 5-5 1.41 1.41L10.83 11z"
            ></path>
            <path
                fill="#08F"
                fillRule="evenodd"
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z"
                clipRule="evenodd"
            ></path>
        </svg>
    )
}